<div class="bmc-connect-replication-detail-properties">

  <div class="bmc-connect-replication-detail-properties__grid">
    <div>
      <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.NAME' | translate}}</div>
      <div>{{infoReplicatedProperties.name}}</div>
    </div>
    <div>
      <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.DISPLAY_NAME' | translate}}</div>
      <div>{{infoReplicatedProperties.displayName}}</div>
    </div>
  </div>

  <div class="bmc-connect-replication-detail-properties__description">
    <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.DESCRIPTION' | translate}}</div>
    <div>{{infoReplicatedProperties.description}}</div>
  </div>

  <div class="bmc-connect-replication-detail-properties__grid">
    <div>
      <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.START_DATE' | translate}}</div>
      <div class="bmc-connect-replication-detail-properties__color-custom">{{infoReplicatedProperties.startDate | date:'short'}}</div>
    </div>
    <div class="bmc-connect-replication-detail-properties__flex">
      <div>
        <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.NEXT_RUN_TIME' | translate}}</div>
        <div *ngIf="infoReplicatedProperties.nextRunTime" class="bmc-connect-replication-detail-properties__color-custom">{{infoReplicatedProperties.nextRunTime | date:'short'}}</div>
      </div>
      <bzg-button-primary type="button" (click)="scheduleNow()">
        {{ 'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.SCHEDULE_NOW' | translate }}
      </bzg-button-primary>
    </div>
  </div>

  <div class="bmc-connect-replication-detail-properties__title bmc-connect-replication-detail-properties__without-nextruntime" *ngIf="!isLoading && !infoReplicatedProperties.nextRunTime">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.NEXT_RUN_TIME_INFO' | translate}}</div>

  <div class="bmc-connect-replication-detail-properties__list" *ngIf="replicatedEntities.length > 0">
    <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.ENTITIES' | translate}}</div>
    <ul>
      <li class="bmc-connect-replication-detail-properties__item" *ngFor="let replicatedEntity of replicatedEntities">{{replicatedEntity.displayName}}</li>
    </ul>
  </div>

  <div class="bmc-connect-replication-detail-properties__list" *ngIf="replicatedEntities.length === 0">
    <div class="bmc-connect-replication-detail-properties__title">{{'PROVIDERS.REPLICATION.PROPERTIES_SECCTION.WITHOUT_ENTITY' | translate}}</div>
  </div>

</div>
